import {hitGoogleTagManager} from "../../tracking/gtm/gtm_hit";

export function hitHmRecommendationsUnsubscribe(clickText: string) {
    const gtmData = {
        event: "automatic_recommendations",
        event_action: "button_click",
        event_label: clickText,
        event_category: "homematch"
    };

    hitGoogleTagManager(gtmData);
}
import {hitGoogleTagManager} from "../../tracking/gtm/gtm_hit";

export function hitHmRecommendationsUnsubscribe(clickText: string) {
    const gtmData = {
        event: "automatic_recommendations",
        event_action: "button_click",
        event_label: clickText,
        event_category: "homematch"
    };

    hitGoogleTagManager(gtmData);
}
